var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "enforcement", title: "Enforcement" } },
    [
      _vm._v("\n  If the "),
      _c("em", [_vm._v("Company")]),
      _vm._v(" discovers reason to believe the "),
      _c("em", [_vm._v("Customer")]),
      _vm._v(" or any of their "),
      _c("em", [_vm._v("Creators")]),
      _vm._v(" has breached this agreement, the\n  "),
      _c("em", [_vm._v("Company")]),
      _vm._v(" may terminate this agreement, restrict the "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("'s ability to download "),
      _c("em", [_vm._v("Pro Icons")]),
      _vm._v(" and "),
      _c("em", [_vm._v("Pro Software")]),
      _vm._v(" from the\n  "),
      _c("em", [_vm._v("Web Store")]),
      _vm._v(", or both. The "),
      _c("em", [_vm._v("Company")]),
      _vm._v(" agrees to send notice to the e-mail address the "),
      _c("em", [_vm._v("Customer")]),
      _vm._v(" provided via the\n  "),
      _c("em", [_vm._v("Web Store")]),
      _vm._v(
        " promptly after terminating this agreement or restricting access. These abilities do not limit the "
      ),
      _c("em", [_vm._v("Company")]),
      _vm._v(
        "'s ability to enforce\n  this this agreement in other ways, such as by taking legal action.\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }